import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export const badgeVariantList = {
  color: {
    info: '',
    destructive: '',
    neutral: '',
    success: '',
    warning: '',
  },
  variant: {
    solid: '',
    outline: 'border',
    soft: '',
  },
  size: {
    sm: 'h-4 px-1 text-[10px]',
    md: 'h-5 px-1.5 text-xs',
    lg: 'h-6 px-1.5 text-sm',
  },
  aspect: {
    default: '',
    rounded: 'rounded-full',
  },
}

export const badgeVariants = cva(
  'inline-flex items-center whitespace-nowrap rounded transition-colors focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 dark:border-neutral-800 dark:focus:ring-neutral-300',
  {
    variants: badgeVariantList,
    compoundVariants: [
      {
        color: 'info',
        variant: 'solid',
        class: 'bg-info-500 text-white',
      },
      {
        color: 'info',
        variant: 'outline',
        class: 'border-info-600 text-info-600',
      },
      {
        color: 'info',
        variant: 'soft',
        class: 'bg-info-100 text-info-700',
      },
      {
        color: 'destructive',
        variant: 'solid',
        class: 'bg-error-500 text-white',
      },
      {
        color: 'destructive',
        variant: 'outline',
        class: 'border-error-600 text-error-600',
      },
      {
        color: 'destructive',
        variant: 'soft',
        class: 'bg-error-100 text-error-700',
      },
      {
        color: 'neutral',
        variant: 'solid',
        class: 'bg-neutral-500 text-white',
      },
      {
        color: 'neutral',
        variant: 'outline',
        class: 'border-neutral-600 text-neutral-600',
      },
      {
        color: 'neutral',
        variant: 'soft',
        class: 'bg-neutral-100 text-neutral-700',
      },
      {
        color: 'success',
        variant: 'solid',
        class: 'bg-success-500 text-white',
      },
      {
        color: 'success',
        variant: 'outline',
        class: 'border-success-600 text-success-600',
      },
      {
        color: 'success',
        variant: 'soft',
        class: 'bg-success-100 text-success-700',
      },
      {
        color: 'warning',
        variant: 'solid',
        class: 'bg-warning-500 text-white',
      },
      {
        color: 'warning',
        variant: 'outline',
        class: 'border-warning-600 text-warning-600',
      },
      {
        color: 'warning',
        variant: 'soft',
        class: 'bg-warning-100 text-warning-700',
      },
    ],
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
